import { useEffect, useState } from "react";
import { getEnvironment } from "../utils/environment";

export const useAppBaseUrl = (): string => {
  const [appBaseUrl, setAppBaseUrl] = useState("");
  useEffect(() => {
    let cancelled = false;
    getEnvironment().then((env) => {
      if (!cancelled && env?.APP_BASE_URL) setAppBaseUrl(env.APP_BASE_URL);
    });
    return () => {
      cancelled = true;
    };
  }, []);
  return appBaseUrl;
};
